// Persons per function — ONE place for the rule, used by Headcount, Cards and
// Expenses (a food estimate can take a function's headcount).
//
//   named guests   parties deduped by mobile (a family invited by several
//                  members counts once); each party = its ExpectedCount.
//   extra cards    a family head may ask for extra cards for people whose names
//                  are unknown. They are invited only to the "extra-card guests
//                  come to" functions of the card type marked ForExtraCards
//                  (the Reception), and count ExtraPersons, or
//                  EXTRA_PERSONS_PER_CARD per card.
import { EXTRA_PERSONS_PER_CARD } from './helpers';

export const rowFunctionIds = (row) => {
  if (row.FunctionIds) return String(row.FunctionIds).split(',').map(v => v.trim()).filter(Boolean);
  return row.FunctionId ? [String(row.FunctionId)] : [];
};

// One household = one card: the family (FamilyId), else the mobile, else the guest.
export const householdKey = (r) => (Number(r.FamilyId || 0)
  ? `fam:${r.FamilyId}` : (r.MobileNumber ? `mob:${r.MobileNumber}` : `g:${r.GuestId}`));

export const extraPersonsFor = (extraCards, extraPersons) => {
  const cards = Math.max(0, Number(extraCards || 0));
  if (!cards) return 0;
  const typed = Number(extraPersons || 0);
  return typed > 0 ? typed : cards * EXTRA_PERSONS_PER_CARD;
};

// The functions extra-card guests come to: the extra-card type's
// ExtraFunctionIds (normally just the Reception), else all its FunctionIds.
export const extraCardFunctionIds = (cardTypes) => new Set(
  (cardTypes || []).filter(t => Number(t.ForExtraCards) === 1)
    .flatMap(t => String(t.ExtraFunctionIds || t.FunctionIds || '').split(',').map(v => v.trim()).filter(Boolean))
);

// Extra cards per household (every row of a household carries the same value).
export function householdExtras(rows) {
  const m = new Map();
  (rows || []).forEach(r => {
    const k = householdKey(r);
    const cards = Number(r.ExtraCards || 0);
    const prev = m.get(k);
    if (!prev || cards > prev.extraCards) m.set(k, { extraCards: cards, extraPersons: Number(r.ExtraPersons || 0), side: r.Side || 'Common' });
  });
  return m;
}

const sideOf = (s) => (s === 'Male' ? 'Groom' : s === 'Female' ? 'Bride' : (s || 'Common'));

// → { parties, persons, named, extra, extraCards, bySide } for one function.
export function functionHeadcount(rows, functionId, cardTypes) {
  const id = String(functionId);
  const seen = new Map();
  (rows || []).filter(r => rowFunctionIds(r).includes(id)).forEach(r => {
    const key = r.MobileNumber || `g${r.GuestId}`;
    const size = Number(r.ExpectedCount || 1);
    const prev = seen.get(key);
    if (!prev || size > prev.size) seen.set(key, { size, side: r.Side || 'Common' });
  });
  const bySide = { Groom: 0, Bride: 0, Common: 0 };
  let named = 0;
  seen.forEach(v => { named += v.size; const s = sideOf(v.side); bySide[s] = (bySide[s] || 0) + v.size; });

  let extra = 0;
  let extraCards = 0;
  if (extraCardFunctionIds(cardTypes).has(id)) {
    householdExtras(rows).forEach(h => {
      const p = extraPersonsFor(h.extraCards, h.extraPersons);
      if (!p) return;
      extra += p; extraCards += h.extraCards;
      const s = sideOf(h.side); bySide[s] = (bySide[s] || 0) + p;
    });
  }
  return { parties: seen.size, named, extra, extraCards, persons: named + extra, bySide };
}
